import React, { useMemo } from 'react';
import { getDesktopImages } from 'components/PdpImageGallery/helpers';
import { DeskTopImageGalleryContainer } from 'components/PdpImageGallery/styled';
import { ImageGalleryProps } from 'components/PdpImageGallery/MobileImageGallery';

export const DesktopImageGallery: React.FC<ImageGalleryProps> = ({ photos, onImageClick }) => {
  const images = useMemo(() =>
      getDesktopImages(photos, onImageClick),
    [onImageClick, photos]);

  return (
    <DeskTopImageGalleryContainer className="desktop-image-gallery-container">
      {images}
    </DeskTopImageGalleryContainer>
  );
};
